import type { CourseThumbnailItem } from "@/types";
import React from "react";
import { Image, XStack, YStack, useMedia } from "tamagui";

type CourseThumbnailCardProps = CourseThumbnailItem & {
  onPress?: () => void;
};

export const COURSE_THUMBNAIL_ASPECT = 3 / 2;

export function CourseThumbnailCard({
  slug,
  thumbnail,
  progressPercentage,
  onPress,
}: CourseThumbnailCardProps) {
  const media = useMedia();
  const width = media.gtMd ? 267 : media.gtSm ? 226 : 160;
  const progressBarHeight = media.gtMd ? 6 : media.gtSm ? 4 : 3;
  const progress = progressPercentage ?? 0;

  return (
    <YStack
      w={width}
      br={8}
      overflow="hidden"
      borderColor="#e0e0e0"
      backgroundColor="#fff"
      style={{ cursor: "pointer" }}
      hoverStyle={{
        scale: 1.03,
        shadowColor: "#000",
        shadowOpacity: 0.2,
        shadowRadius: 10,
      }}
      pressStyle={{ scale: 0.98, opacity: 0.9 }}
      animation="bouncy"
      onPress={onPress}
    >
      {thumbnail ? (
        <Image
          source={{ uri: thumbnail }}
          w="100%"
          aspectRatio={COURSE_THUMBNAIL_ASPECT}
          resizeMode="cover"
        />
      ) : (
        <YStack
          w="100%"
          aspectRatio={COURSE_THUMBNAIL_ASPECT}
          backgroundColor="#b0d0ff"
        />
      )}

      <XStack h={progressBarHeight} backgroundColor="#D2CCC5" overflow="hidden">
        <YStack
          h="100%"
          backgroundColor="$accent"
          borderRadius={30}
          w={`${progress}%`}
        />
      </XStack>
    </YStack>
  );
}
